var $b2b55661291de587$exports = {};
$b2b55661291de587$exports = {
    "removeButtonLabel": `Odebrat`,
    "removeDescription": `Stisknut\xedm kl\xe1vesy Delete odeberete zna\u{10D}ku.`
};


export {$b2b55661291de587$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
